import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsTermsOfUseAPI extends ComponentAPI<{ enabled: boolean }> {

  @AwesomeEvent
  public onClickTerm = new ClickEventListener();

  @AwesomeEvent
  public onClickWarning = new ClickEventListener();

  public setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  public isEnabled(): boolean {
    return this.state.enabled;
  }
}

export {
  HpmsTermsOfUseAPI,
};
